// extracted by mini-css-extract-plugin
export var emailBlockLink = "_pa-0";